<template>
  <div v-if="call !== null" class="quality-info">
    <QualityInfo :uid="uid"></QualityInfo>
  </div>
</template>

<script>

import QualityInfo from "~/components/partials/QualityInfo";
import {mapGetters} from "vuex";

export default {
  name: "OperatorsQualityProjects",
  components: {
    QualityInfo,
  },

  data() {
    return {
      uid: null,
    }
  },

  mounted() {
    this.uid = this.$route.params.uid;
  },

  computed: {
    ...mapGetters({
      call: 'reports/call',
    }),
  }
}
</script>

<style scoped>
.quality-info {
  padding-bottom: 70px;
}
</style>